import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Sparkles, Bug, Wrench, Zap, Globe2 } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const RELEASES = [
  {
    version: '3.26.4',
    date: '2026-05-03',
    label: 'Polish',
    icon: <Wrench size={18} />,
    items: [
      { type: 'feat', text: 'Date format dinamico in base alla lingua impostata (it-IT / en-US / es-ES / fr-FR / de-DE)' },
      { type: 'feat', text: 'Bottone "Svuota" su ogni sezione cronologia (Contenuti AI, AEO, Local SEO, Analisi, ecc.)' },
    ],
  },
  {
    version: '3.26.3',
    date: '2026-05-03',
    label: 'Fix Articolo Completo wallet',
    icon: <Bug size={18} />,
    items: [
      { type: 'fix', text: '/ai/complete-article migrato dal vecchio modello ai_credits al wallet system (plan_credits + topup_credits). Risolve bug "Crediti insufficienti. Servono 25 crediti" su licenze Team con wallet pieno.' },
      { type: 'fix', text: 'Refund automatico via add_credits() se la generazione fallisce.' },
    ],
  },
  {
    version: '3.26.2',
    date: '2026-05-03',
    label: 'Articolo Completo timeout + estensione',
    icon: <Wrench size={18} />,
    items: [
      { type: 'fix', text: 'Timeout WP wp_remote_post: 90s → 180s per /ai/complete-article e /ai/generate-image. Risolve "Articolo Completo riparte da zero" causato da WP timeout silenzioso.' },
      { type: 'feat', text: 'Bottone "⭐ Articolo Completo AI" ora disponibile anche su Local SEO e Contenuti AEO (era solo su Contenuti AI).' },
      { type: 'feat', text: 'Local SEO action bar potenziata con Pubblica Subito, Anteprima theme, Foto da Media, Genera Foto AI.' },
    ],
  },
  {
    version: '3.26.1',
    date: '2026-05-03',
    label: 'UX flow improvements',
    icon: <Sparkles size={18} />,
    items: [
      { type: 'feat', text: 'Tooltip e inline help su differenza "Genera Articolo" (8 crediti, solo testo) vs "Articolo Completo AI" (25 crediti, testo + immagine + meta).' },
      { type: 'feat', text: 'Anteprima usa il theme reale del sito: AJAX crea bozza auto-draft → apre WP preview URL → si vede col template del tema attivo.' },
      { type: 'feat', text: '"Genera Foto AI" pre-compila automaticamente il prompt con i temi visivi estratti dall\'articolo (no più input vuoto).' },
      { type: 'feat', text: 'Bulk Meta Tags: nuovo flow review-then-apply. Genera proposte (no save) → tabella editabile → user modifica title/description → "Salva selezionate" applica solo le scelte.' },
    ],
  },
  {
    version: '3.26.0',
    date: '2026-05-03',
    label: 'Backend AI multilingua + bug fixes',
    icon: <Globe2 size={18} />,
    items: [
      { type: 'feat', text: 'Backend AI ora genera contenuti direttamente nella lingua impostata: IT, EN, ES, FR, DE. Plugin auto-injecta language nelle chiamate AI insieme a Brand Voice.' },
      { type: 'feat', text: 'AEO target engines estesi: Claude (Anthropic), Grok (xAI), Meta AI, DuckDuckGo AI. Totale 8 engine supportati.' },
      { type: 'fix', text: 'Auto-Pilot: keyword selezionate via picker non venivano salvate al create job. Picker ora emette evento custom orch-kp:applied prima di clearare le checkbox.' },
    ],
  },
  {
    version: '3.25.0 — 3.25.12',
    date: '2026-05-03',
    label: 'i18n EN coverage',
    icon: <Globe2 size={18} />,
    items: [
      { type: 'feat', text: 'Foundation i18n: SEO_AEO_T translator class lightweight, ~470 traduzioni IT→EN.' },
      { type: 'feat', text: 'Switch lingua dalle Impostazioni: IT (default) o EN. Submenu admin, hero pagine, form labels, JS toast e confirm, 12 cards Wizard, Settings, Migration Wizard, Cronologia, Schema validator, Cannibalization, GSC tutto wrapped.' },
      { type: 'feat', text: 'Coverage ~99% UI shell. Resta solo content dinamico generato da AI (gestito da language param backend).' },
    ],
  },
  {
    version: '3.24.0',
    date: '2026-05-03',
    label: 'Auto-Pilot Scheduler',
    icon: <Sparkles size={18} />,
    items: [
      { type: 'feat', text: '🤖 Nuovo submenu "Auto-Pilot": cron WP che ogni N giorni pesca da un set keyword, genera articolo completo (testo + immagine + meta + Brand Voice), crea WordPress draft o publish.' },
      { type: 'feat', text: 'Job recurring configurabili: frequenza (1/3/7/14/30 giorni), lunghezza, post status, categoria, autore, immagine on/off.' },
      { type: 'feat', text: 'Log esecuzione + retry automatico in 1h se backend fallisce + auto-pause job quando set keyword esaurito.' },
    ],
  },
  {
    version: '3.23.0',
    date: '2026-05-02',
    label: 'Keyword Research Autopilot',
    icon: <Sparkles size={18} />,
    items: [
      { type: 'feat', text: '🎯 Da nicchia a 30 keyword strategiche organizzate in cluster semantici, con volume stimato, difficoltà, intent, idea articolo.' },
      { type: 'feat', text: 'Picker globale "📥 Pesca da Keyword Research" disponibile in 5 pagine di generazione (Contenuti AI, AEO, Local, Analisi, Meta Tags).' },
      { type: 'feat', text: 'Export CSV + bottone diretto "Genera articolo" da ogni keyword (atterra su Contenuti AI con prefill).' },
    ],
  },
  {
    version: '3.22.0',
    date: '2026-05-02',
    label: 'Wizard onboarding + Cronologia framework',
    icon: <Sparkles size={18} />,
    items: [
      { type: 'feat', text: '🪄 Wizard come prima pagina del plugin: hero, 4 quickstart steps, 12 feature cards, news, guide links, support card.' },
      { type: 'feat', text: 'Framework Cronologia "Riapri": form-restore (campi + output) per pagine standard, viewer modal per nested flows (article generato da suggestion, complete article, AI image).' },
    ],
  },
  {
    version: '3.21.0',
    date: '2026-05-02',
    label: 'Brand Voice Learning',
    icon: <Sparkles size={18} />,
    items: [
      { type: 'feat', text: '🎙️ Brand Voice Learning: AI analizza i tuoi articoli e crea profilo (tono, vocabolario, anti-cliché, summary). Applicato a OGNI generazione AI (6 endpoint).' },
      { type: 'feat', text: 'Profili multipli per agenzie. Edit inline dalla pagina di generazione con drawer "Quick Edit".' },
      { type: 'feat', text: 'Auto-image-from-content: il prompt immagine deriva dai temi visivi dell\'articolo, non dal solo titolo.' },
    ],
  },
  {
    version: '3.20.0',
    date: '2026-05-02',
    label: '"Switch da Yoast" complete',
    icon: <Zap size={18} />,
    items: [
      { type: 'feat', text: 'Stack Native completo per sostituire Yoast/RankMath/AIOSEO: Output Renderer, Override Mode, Sitemap.xml, llms.txt, llms-full.txt, Schema.org dinamico, Redirect Manager, AI 404 Suggester.' },
      { type: 'feat', text: '🚀 Migration Wizard 6-step: scan, backup JSON, copia meta tags shadow-copy, import redirect, attiva stack, disinstall guidato.' },
      { type: 'feat', text: 'Cannibalization detector + AI Resolution con "Applica con un click" e snapshot per restore.' },
    ],
  },
];

const ChangelogPage = () => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = 'Changelog · AEO Orchestra';
      window.scrollTo(0, 0);
    }
  }, []);

  const typeColor = {
    feat: { bg: 'bg-[#0055FF]/15', border: 'border-[#0055FF]/30', text: 'text-[#3377FF]', label: 'NEW' },
    fix: { bg: 'bg-[#10B981]/15', border: 'border-[#10B981]/30', text: 'text-[#10B981]', label: 'FIX' },
    perf: { bg: 'bg-[#F59E0B]/15', border: 'border-[#F59E0B]/30', text: 'text-[#F59E0B]', label: 'PERF' },
  };

  return (
    <>
      <Header />
      <main className="pt-24 pb-24 bg-[#0a0a0a] min-h-screen">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/guide" className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#0055FF] mb-8 text-sm transition-colors">
            <ArrowLeft size={16} /> Tutte le guide
          </Link>

          <div className="mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0055FF]/10 border border-[#0055FF]/20 text-[#0055FF] text-xs font-medium uppercase tracking-wider mb-5">
              <Sparkles size={12} /> Aggiornamenti
            </div>
            <h1 className="font-['Outfit'] text-4xl md:text-5xl font-bold text-white tracking-tight leading-tight mb-4">
              Changelog
            </h1>
            <p className="text-lg text-[#A1A1AA] leading-relaxed">
              Tutte le release di AEO Orchestra, versione per versione. Le date e i numeri di versione
              sono quelli delle release del plugin WordPress.
            </p>
          </div>

          <div className="space-y-8">
            {RELEASES.map((r) => (
              <div key={r.version} className="bg-[#111111] border border-white/10 rounded-2xl p-7">
                <div className="flex items-start justify-between flex-wrap gap-3 mb-5 pb-4 border-b border-white/5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-[#0055FF]/10 border border-[#0055FF]/20 flex items-center justify-center text-[#3377FF]">
                      {r.icon}
                    </div>
                    <div>
                      <div className="flex items-center gap-3 mb-1">
                        <h2 className="font-['Outfit'] text-2xl font-bold text-white">v{r.version}</h2>
                        <span className="text-xs text-[#666]">{r.date}</span>
                      </div>
                      <p className="text-[#A1A1AA] text-sm">{r.label}</p>
                    </div>
                  </div>
                </div>
                <ul className="space-y-3">
                  {r.items.map((it, i) => {
                    const c = typeColor[it.type] || typeColor.feat;
                    return (
                      <li key={i} className="flex items-start gap-3">
                        <span className={`flex-shrink-0 inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${c.bg} border ${c.border} ${c.text}`}>
                          {c.label}
                        </span>
                        <span className="text-[#C8C8CC] text-sm leading-relaxed">{it.text}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 p-6 rounded-2xl bg-gradient-to-br from-[#0055FF]/10 to-[#00E5FF]/5 border border-[#0055FF]/20 text-center">
            <p className="text-[#A1A1AA] text-sm mb-3">
              Le release prima della 3.20 (3.0 → 3.19) sono in <a href="https://www.notion.so/SEO-Orchestra-AI-Documentazione-33df9a7f769d804faba0f60148b5d2c8/changelog" target="_blank" rel="noopener noreferrer" className="text-[#0055FF] hover:underline">Notion</a>.
            </p>
            <Link to="/guide" className="inline-flex items-center gap-2 text-white hover:text-[#3377FF] text-sm font-medium transition-colors">
              ← Tutte le guide
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ChangelogPage;
